import { TranslateService } from '@ngx-translate/core';

export const getRvDerogationStatusTranslation = (
  rvDerogationStatus: string,
  translateService: TranslateService
): string => {
  switch (rvDerogationStatus) {
    case '1':
      return translateService.instant('application.records.table.rvDerogationStatusDetails.pending');
    case '2A':
      return translateService.instant('application.records.table.rvDerogationStatusDetails.accepted');
    case '2B':
      return translateService.instant('application.records.table.rvDerogationStatusDetails.refused');
    case '2C':
      return translateService.instant('application.records.table.rvDerogationStatusDetails.canceled');
    case '3':
      return translateService.instant('application.records.table.rvDerogationStatusDetails.processed');
    default:
      return '';
  }
};
